import * as Yup from "yup";
import { organizationNoValidate } from "us.collection/functions";
import {
	validateOrganizationNumber,
  validatePersonNo,
  validateSwedishNumber,
} from "../DebtorInfo/Functions";
import { SystemCountryCodeFormat } from "../DebtorInfo/Constants";

export default () => {
  return Yup.object().shape({
    lastName: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
    ),
    email: Yup.string()
      .email(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      )
      .nullable(),
    companyNo: Yup.string().when("debtorType", {
      is: (val) => val === "N",
      then: Yup.string()
        .typeError(
          "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
        )
        .test(
          "len",
          "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
          function (value) {
            if (!value) return true; // skip if empty, use .required() for required
            const systemCountryCode = this.parent.systemCountryCode;          
            if (
              systemCountryCode?.toLowerCase() === SystemCountryCodeFormat.NO
            ) {
              return organizationNoValidate(value);
            } else {
              return true;
            }
          }
        ),
    }),
    systemCountryCode: Yup.string(),
    personNo: Yup.string().test(
      "is-valid-se-person-number",
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
      function (value) {
        if (!value) return true; // skip if empty, use .required() for required
        const systemCountryCode = this.parent.systemCountryCode; 
        if (
          systemCountryCode?.toLowerCase() === SystemCountryCodeFormat.NO
        ) {
          const result = validatePersonNo(value.replaceAll(/\D/g, ""));
          return result.isValid;
        } else {
          return true;
        }
      }
    ),
    home: Yup.string()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      )
      .matches(
        /^\d{4,15}$/g,
        "US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS"
      )
      .nullable(),
    mobile: Yup.string()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      )
      .matches(
        /^\d{4,15}$/g,
        "US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS"
      )
      .nullable(),
    work: Yup.string()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      )
      .matches(
        /^\d{4,15}$/g,
        "US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS"
      )
      .nullable(),
    sms: Yup.string()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      )
      .matches(
        /^\d{4,15}$/g,
        "US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS"
      )
      .nullable(),
    zipCode: Yup.string()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      )
      .when("addrUnknown", {
        is: false,
        then: Yup.string().required(
          "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
        ),
      })
      .when(["countryCode", "systemCountryCode"], {
        is: (countryCode: string, systemCountryCode: string) =>
          countryCode === systemCountryCode,
        then: Yup.string().matches(
          /^\d+$/,
          "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
        ),
      }),
    zipName: Yup.string()
      .nullable()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      )
      .when(["zipCode", "addrUnknown"], {
        is: (zipCode, addrUnknown) => {
          zipCode = typeof zipCode == "undefined" ? "" : zipCode;
          return zipCode?.toString().length !== 0 && !addrUnknown;
        },
        then: Yup.string()
          .required(
            "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
          )
          .test(
            "zipNameDigit",
            "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
            (val: any) => {
              let value = typeof val == "undefined" ? "" : val;
              return !/^\d+$/.test(value);
            }
          ),
      }),
    municipalityCode: Yup.string()
      .nullable()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      ),
    municipalityName: Yup.string()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      )
      .nullable(),
  });
};
